import { useFirebase } from "containers/FirebaseContext";
import { collection, deleteDoc, doc, doc as firestoreDoc, getDoc, getDocs, query, setDoc, updateDoc, where } from "firebase/firestore";
import * as Sentry from '@sentry/react';

export const useCollectionAutoSubmission = () => {
    const { firestore } = useFirebase();
    const createCollectionSubmission = async (submissionData, submissionsId) => {
        try {
            const generatedId = submissionsId;
            const docRef = firestoreDoc(firestore, "auto_submission", generatedId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                await updateDoc(docRef, submissionData)
            } else {
                await setDoc(docRef, submissionData)
            }
            return;
        } catch (error) {
            console.log(error, "error");
            Sentry.captureException(`114 Error during Firebase createCollectionSubmission ${error}.`);
        }
    }
    const updateCollectionSubmission = async (id, userId) => {
        try {
            const notificationsRef = collection(firestore, "auto_submission");
            const q = query(notificationsRef, where("id", "==", id));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach(async (doc) => {
                const data = doc.data();
                const existingUser = data.userSeen && data.userSeen.includes(userId);
                if (!existingUser) {
                    const docRef = firestoreDoc(notificationsRef, doc.id);
                    await updateDoc(docRef, {
                        userSeen: [...(data.userSeen || []), userId]
                    });
                }
            })
        } catch (error) {
            Sentry.captureException(`115 Error during Firebase updateCollectionSubmission ${error}.`);
        }
    }

    const deleteSubmissionData = async (docId) => {
        try {
            const docRef = doc(firestore, "auto_submission", docId);
            await deleteDoc(docRef);
        } catch (error) {
            console.error("Error deleting document: ", error);
            Sentry.captureException(`116 Error during Firebase deleteSubmissionData ${error}.`);
        }
    };

    return { createCollectionSubmission, updateCollectionSubmission, deleteSubmissionData }
}